import { debounceTime } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { SimpleQueryResponse } from './../../../../shared/dtos/simpleQueryResponse';
import { FournisseurService } from 'src/app/shared/services/societe-linked/fournisseur.service';
import { FiltreService } from 'src/app/core/filtre.service';
import { FilterFournDTO } from './../../../../shared/dtos/filterFournDTO';
import { FormGroup, FormControl } from '@angular/forms';
import { FournisseurModel } from './../../../../shared/models/societe-linked/fournisseur.model';
import { Component, OnInit, ViewChild, Inject } from '@angular/core';

export interface DialogData {
  idSociete: number;
}

@Component({
  selector: 'app-modal-recherche-fournisseur',
  templateUrl: './modal-recherche-fournisseur.component.html',
  styleUrls: ['./modal-recherche-fournisseur.component.scss']
})
export class ModalRechercheFournisseurComponent implements OnInit {
  private filteredSubscribe: Subscription;
  panelOpenState = true;
  loading = false;
  dataSource: FournisseurModel[];
  filtreData: FilterFournDTO = new FilterFournDTO();
  fournList: FournisseurModel[] = [];
  simpleQueryFournResponse = new SimpleQueryResponse<FournisseurModel>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  constructor(private filtreService: FiltreService,
              private fournisseurService: FournisseurService,
              public dialog: MatDialog,
              public router: Router,
              public dialogRef: MatDialogRef<Component>,
              @Inject(MAT_DIALOG_DATA) public data: DialogData) {
  }

  ngOnInit(): void {
    this.filtreData.idSociete = this.data.idSociete;
  }

  setFournisseur(fournisseur: FournisseurModel): void{
    this.dialogRef.close(fournisseur);
  }

  onChange(event): void {
    this.fournisseurService.getFiltredFournisseur(this.filtreData).subscribe((data: SimpleQueryResponse<FournisseurModel>) => {
      this.simpleQueryFournResponse = data;
      this.fournList = data.objets;
    });
  }

  onModalCancel(): void {
    this.dialogRef.close(false);
  }


}
